import { gql } from '@apollo/client';

export const OPS_TOOL_DSP_DRIVER_SUMMARY = gql`
  query OpsToolDspDriverSummary(
    $filters: OpsDspDriverSummaryFilterInput!
    $pageRequest: PageRequestTypeInput
  ) {
    opsToolDspDriverSummary(filters: $filters, pageRequest: $pageRequest) {
      success
      code
      message
      content {
        deliveredDate
        driverId
        oneSortingCode
        twoSortingCode
        threeSortingCode
        totalPackageCount
        fullPricePackageCount
        discountPricePackageCount
        originalPackageTotalAmount
        fullPriceDeliveredAmount
        discountDeliveredAmount
        settlementAmount
      }
      totalElements
      page
      size
    }
  }
`;

export const OPS_TOOL_DSP_DRIVER_DETAIL = gql`
  query OpsToolDspDriverDetail(
    $filters: OpsDspDriverDetailFilterInput!
    $pageRequest: PageRequestTypeInput
  ) {
    opsToolDspDriverDetail(filters: $filters, pageRequest: $pageRequest) {
      success
      code
      message
      content {
        id
        deliveredDate
        businessId
        billId
        hubId
        dspId
        driverId
        driverPhone
        driverName
        oneSortingCode
        twoSortingCode
        threeSortingCode
        settlementAmount
        originAmount
        discountAmount
        discountFlag
        normalAddress
        groupId
        groupSort
      }
      totalElements
      page
      size
    }
  }
`;

export const OPS_TOOL_DSP_DRIVER_CLEARING = gql`
  query OpsToolDspDriverClearing($businessId: String!) {
    opsToolDspDriverClearing(businessId: $businessId) {
      id
      settlementClientId
      settlementItemId
      settlementItemCode
      settlementItemName
      amount
      amountHm
      businessId
      otherBusinessId
      status
      pricingId
      businessTime
      settlementTime
      clearingNode
      isDeleted
      createdAt
    }
  }
`;

export const OPS_TOOL_DSP_DRIVER_ENTRY = gql`
  query OpsToolDspDriverEntry($billId: Long!, $businessId: String!) {
    opsToolDspDriverEntry(billId: $billId, businessId: $businessId) {
      id
      billId
      clearingId
      businessId
      settlementFeeItem
      amount
      amountHm
      createdAt
    }
  }
`;
